import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from '../ui/SectionHeading';
import { BookOpen, Brain, Scissors, Users, DollarSign, LayoutDashboard } from 'lucide-react';
export function WhatYouGetSection() {
  const modules = [{
    icon: <Brain className="w-8 h-8 text-rose-500" data-id="element-245" />,
    title: 'Mentalidad',
    desc: 'Para empezar y superar bloqueos'
  }, {
    icon: <Scissors className="w-8 h-8 text-rose-500" data-id="element-246" />,
    title: 'Manicuría desde cero',
    desc: 'Herramientas, práctica y base real'
  }, {
    icon: <Users className="w-8 h-8 text-rose-500" data-id="element-247" />,
    title: 'Primeras clientas',
    desc: 'Cómo conseguir tus primeras clientas'
  }, {
    icon: <DollarSign className="w-8 h-8 text-rose-500" data-id="element-248" />,
    title: 'Precios y dinero',
    desc: 'Cómo generar ganancias reales'
  }, {
    icon: <LayoutDashboard className="w-8 h-8 text-rose-500" data-id="element-249" />,
    title: 'Organización',
    desc: 'Experiencia del cliente y crecimiento del negocio'
  }];
  return <section className="py-24 bg-rose-50" data-id="element-250">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-251">
        <div className="text-center mb-16" data-id="element-252">
          <motion.div initial={{
          opacity: 0,
          scale: 0.5
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-rose-100 text-rose-500 mb-6" data-id="element-253">
            <BookOpen className="w-8 h-8" data-id="element-254" />
          </motion.div>
          <SectionHeading title="Qué incluye el producto" subtitle="Dentro del Ebook “Empezá y Ganá” vas a encontrar:" data-id="element-255" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-256">
          {modules.map((mod, index) => <motion.div key={index} className="bg-white rounded-2xl p-8 shadow-soft border border-rose-100 hover:shadow-lg hover:-translate-y-1 transition-all duration-300" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} data-id="element-257">
              <div className="bg-rose-50 w-16 h-16 rounded-xl flex items-center justify-center mb-6" data-id="element-258">
                {mod.icon}
              </div>
              <h4 className="text-xl font-playfair font-bold text-dark mb-2" data-id="element-259">
                {mod.title}
              </h4>
              <p className="text-dark-light" data-id="element-260">{mod.desc}</p>
            </motion.div>)}

          {/* Decorative filler card for the 6th spot in a 3-col grid */}
          <motion.div className="bg-gradient-to-br from-rose-400 to-rose-600 rounded-2xl p-8 shadow-soft text-white flex flex-col justify-center items-center text-center" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5,
          duration: 0.5
        }} data-id="element-261">
            <h4 className="text-2xl font-playfair font-bold mb-2" data-id="element-262">
              Todo en un solo lugar
            </h4>
            <p className="text-rose-100" data-id="element-263">
              Acceso inmediato desde cualquier dispositivo
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}